export const LEGACY_TO_NEW_ROUTE_MAP: Record<string, string> = {
  '/events': '/monitoring/events',
  '/license-plate': '/monitoring/license-plate',
  '/camera-mosaic': '/monitoring/camera-mosaic',
  '/facial-recognition': '/monitoring/facial-recognition',
  '/live-tracking': '/monitoring/live-tracking',
  '/registers/devices': '/registers/devices',
  '/registers/clients': '/registers/clients',
  '/registers/lists': '/registers/lists',
  '/registers/edge-servers': '/registers/edge-servers',
  '/administrative/companies': '/registers/companies',
  '/administrative/quotas': '/registers/quotas',
  '/registers/users': '/registers/users',
  '/registers/alarm-centers': '/registers/alarm-centers',
  '/settings/inputs': '/settings/inputs',
  '/settings/outputs': '/settings/outputs',
}
